module.exports = __webpack_public_path__ + "img/image2.353962e8.png";